/**!
 * SACE ATAR Calculator
 * By Daniel15 - 2011-2019
 * Feel free to use any of this, but please link back to my site (dan.cx)
 */

import '../../css/main.css';

import React from 'react';
import ReactDOM from 'react-dom';

import {initAnalytics} from '../analyticsLogger';
import CalculatorSACE from '../components/CalculatorSACE';
import CalculatorContainer from '../containers/CalculatorContainer';
import Data from '../../data/sace.json';
import {State} from '../constants';

ReactDOM.render(
  <CalculatorContainer
    appConfig={{
      ...Data,
      alertMessage: null,
      bugReportMessage: (
        <>
          Please report any issues to{' '}
          <a href="mailto:%63%61l&#99;%40at%61r%6e%6ftes%2e&#99;om">
            calc@atarnotes.com
          </a>
        </>
      ),
      resourcesURL: null,
      showSuggestedCourses: false,
      state: State.SACE,
    }}
    calculator={CalculatorSACE}
  />,
  document.getElementById('calculator'),
);

initAnalytics(State.SACE);
